import React from "react";
import {
  withStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import styles from "./MapPopupStyles.js";
import Tooltip from '@material-ui/core/Tooltip';
import "./style.scss";

const CustomTooltip = ({ theme, title, children }) => {
  return (
    <Tooltip classes={{ popper: "popper", tooltip: `tooltip-${theme}` }} title={title}>
      {children}
    </Tooltip>
  );
}

const CustomerPopup = ({classes, theme, data}) => {
  return(
    <Paper className={`${classes.routeStop} popupBGColor`}>
      <Table className={classes.table} padding="none">
        <TableHead className={classes.tableHead}>
          <TableRow className={classes.tableHeadHeight}>
            <TableCell colSpan={2} className={classes.tableHeaderCell}>
              <CustomTooltip title={data.name} theme={theme}>
                <div className={classes.customerName}>
                  {data.name}
                </div>
              </CustomTooltip>
              <CustomTooltip title={data.routeName} theme={theme}>
                <span className={classes.routeInfo}>
                  {data.routeName}
                </span>
              </CustomTooltip>
              <CustomTooltip title={data.address} theme={theme}>
                <div className={classes.address}>{data.address}</div>
              </CustomTooltip>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={classes.tableRowRoot}>
            <TableCell className={`${classes.nameCellPadding} ${classes.labelCell} tableCellName`}>Service Window</TableCell>
            <TableCell className={`${classes.dataCell} tableCellValue`}>
            {`${data.openHours} - ${data.closeHours}`}
            </TableCell>
          </TableRow>
          {data.specialInstruction &&
          <TableRow className={classes.tableRowRoot}>
            <TableCell className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.lastTableCell} tableCellName`}>Special Instructions</TableCell>
            <TableCell className={`${classes.dataCell} ${classes.lastTableCell} tableCellValue`}>
              <CustomTooltip title={data.specialInstruction} theme={theme}>
                <div className={classes.SpecialInstruction}>{data.specialInstruction}</div>
              </CustomTooltip>
            </TableCell>
          </TableRow>}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default withStyles(styles)(CustomerPopup);